<router-outlet></router-outlet>

<app-loading-overlay [showOverlay]="showGlobalOverlay" [black]="true">
    <div class="text-lg text-white">Seite wird geladen...</div>
</app-loading-overlay>
